// Settings > Integrations > Email: the card's chip and line (spec E2 PR 4 item
// 6, the approved prototype's renderNeighbours, index.html:1276-1278).
//
// The address the emails come from is set up in the Your domain card, so this
// card only says where they come from now, and points there until a domain is
// verified. Status is a word and an icon (the Your domain card's chip), never
// colour alone. The button stays "Email settings" (index.html): the business
// name, the reply-to address and the test send.
//
// One painter: app.js loadCommsCardStatuses calls this after it refreshes the
// email status, on every Settings render and every Integrations tab open, and
// the Your domain card asks it to run again after a Check or a disconnect.
import { chip, esc } from './your-domain-view.js';
import { emailDomainVerified } from './email-domain-status.js';

/**
 * @param {any} settings the coach's settings
 */
export function paintEmailCard(settings) {
  const emailStatus = document.getElementById('comms-card-email-status');
  const emailCheck = document.querySelector('.comms-channel-check[data-channel="email"]');
  const emailDesc = document.getElementById('email-card-desc');
  const verified = emailDomainVerified(settings);
  if (emailStatus) emailStatus.innerHTML = chip(verified ? 'fromyours' : 'fromfitops');
  if (emailDesc) {
    emailDesc.innerHTML = 'Your business name, the reply-to address and a test email. ' + (verified
      ? 'Your emails come from notifications@' + esc(String(settings.emailDomain).trim().toLowerCase()) + ', with your business name on them.'
      : 'Until <button class="yd-link" data-go="domain">Your domain</button> is set up, your emails come from notifications@fitopspro.com, with your business name on them.');
  }
  if (verified && emailCheck) { emailCheck.checked = true; emailCheck.disabled = true; }
}
